<template>
  <div class="public" :class="{ 'public-home': isHomePage }">
    <router-view v-if="!loading" />
    <login-error v-if="loginFail" />
  </div>
</template>

<script>
import { loginByAiisToken } from '@/api/user'
import LoginError from './pannel/loginError.vue'

export default {
  components: {
    LoginError,
  },
  data() {
    return {
      loading: true,
      loginFail: false,
      isHomePage: false,
    }
  },
  watch: {
    '$route.path': {
      handler(e) {
        this.isHomePage = e === '/home'
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.loading = true
    const { token } = this.$route.query
    if (token) {
      const params = {
        aiis_token: token,
        grant_type: 'aiis_token',
      }
      loginByAiisToken(params).then(async (res) => {
        const { data } = res
        if (data.access_token) {
          this.$store.commit('SET_AIIS_TOKEN', token)
          this.$store.commit('SET_TOKEN', data.access_token)
          this.$store.commit('saveUserInfo', data)
          this.$store.commit('SET_REFRESH_TOKEN', data.refresh_token)
          this.$store.commit('SET_TENANT_ID', data.tenant_id)
          this.$store.commit('SET_USER_INFO', data)

          await this.$store.dispatch('GetUserInfo')
          await this.$store.dispatch('GetDicts')
          await this.$store.dispatch('GetTemplateForm')

          this.loading = false
        } else {
          this.loginFail = true
        }
      })
    } else {
      this.loginFail = true
    }
  },
  methods: {
    handleBack() {},
  },
}
</script>
<style lang="scss">
.public {
  padding: 10px;
  height: 100%;
  position: relative;
  top: 60px;
  &-home {
    top: 0;
    .c-drawer > .b-sidebar-outer > .b-sidebar {
      height: calc(100vh - 60px) !important;
    }

    .home-page-drawerShow {
      padding-top: 60px;
    }
  }
  .apply-list {
    .c-drawer > .b-sidebar-outer > .b-sidebar {
      height: calc(100vh - 60px) !important;
    }
  }
}
</style>
